<template>
    <div class="animated fadeIn">
        <div>
            <b-row>
                <b-col>
                    <h4>Lead Management</h4>
                </b-col>
                <b-col md="2">
                    <eb-select
                        v-if="hideSelect"
                        type="select"
                        style="font-size: 12px; font-weight: 600"
                        v-model="selectedDurationOption"
                        :options="durationOptions"
                        label="text"
                        :id="'selectduration'"
                        :placeholder="'Time Duration'"
                        :selected="selectedDurationOption.text"
                        @input="changeDuration"
                    ></eb-select>
                    <c-date
                        ref="compRefs"
                        modalRef="modalRef"
                        modalId="dateModal"
                        @customDateRange="findDateResult"
                    ></c-date>
                </b-col>
                <b-col md="2">
                    <eb-select
                        id="selectSearch"
                        v-model="selectSearch"
                        :options="searchOptions"
                        label="text"
                        placeholder="Select Search"
                        :selected="selectSearch"
                        class="w-100"
                        @input="searchValue = ''"
                    ></eb-select>
                </b-col>
                <b-col md="4">
                    <ValidationProvider
                        :rules="getValidationRules(selectSearch.value)"
                        v-slot="{ errors }"
                        name="Search"
                    >
                        <CustInput
                            inputType="text"
                            inputId="search"
                            :lableText="
                                selectSearch
                                    ? 'Search ' + selectSearch.text
                                    : 'Search...'
                            "
                            v-model="searchValue"
                            @keyup.enter.native="onSearchInput"
                            class="w-100"
                        />
                        <span v-if="searchValue" class="validate-error">{{
                            errors[0]
                        }}</span>
                    </ValidationProvider>
                    <button class="text-grey searchIcon" @click="onSearchInput">
                        <i class="fa fa-search mt-2" aria-hidden="true"></i>
                    </button>
                </b-col>
                <!-- <b-col md="4">
                    <CustInput
                        inputType="text"
                        inputId="search"
                        :lableText="
                            selectSearch
                                ? 'Search ' + selectSearch.text
                                : 'Search...'
                        "
                        v-model="searchValue"
                        @keyup.enter.native="onSearchInput"
                        class="w-100"
                    />
                    <button class="text-grey searchIcon" @click="onSearchInput">
                        <i class="fa fa-search mt-2" aria-hidden="true"></i>
                    </button>
                </b-col> -->
                <!-- <b-col md="2">
                    <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Select Search"
                    >
                    <label for="assetCategory">Asset Category *</label>
                    <eb-select
                        id="selectTenant"
                        v-model="selectTenant"
                        :options="tenantOptions"
                        label="text"
                        placeholder="Select Tenant"
                        class="w-100"
                    ></eb-select>
                    <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                </b-col> -->
            </b-row>
        </div>
        <b-card>
            <b-row>
                <b-col sm="6" lg="2">
                    <dashboardInfoCard
                        labelText="Total"
                        :value="contactEnquiryList.totalCount"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="2">
                    <dashboardInfoCard
                        labelText="Open"
                        :value="getStatusCount('OPEN')"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="2">
                    <dashboardInfoCard
                        labelText="Closed"
                        :value="getStatusCount('CLOSED')"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="2">
                    <dashboardInfoCard
                        labelText="Clarification"
                        :value="getStatusCount('CLARIFICATION')"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="2">
                    <dashboardInfoCard
                        labelText="Reopen"
                        :value="getStatusCount('REOPEN')"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="2">
                    <dashboardInfoCard
                        labelText="Resolved"
                        :value="getStatusCount('RESOLVED')"
                        bottomColor="#42b039"
                    ></dashboardInfoCard>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col>
                    <div>
                        <div class="">
                            <b-table
                                style="border-radius: 12px"
                                id="contactUs"
                                :dark="false"
                                :hover="true"
                                :striped="true"
                                :bordered="true"
                                :small="false"
                                :fixed="false"
                                responsive
                                class="tableRadius"
                                :items="filteredList"
                                :fields="contactUsColumns"
                                :current-page="currentPage"
                                :per-page="perPage"
                                filter
                                thead-class="header"
                                show-empty
                                :busy="loading"
                            >
                                <template slot="action" slot-scope="data">
                                    <div class="inline_btnTable">
                                        <b-button
                                            size="sm"
                                            class="button-circle mr-2"
                                            variant="primary"
                                            @click="
                                                viewContactUsDetails(data.item)
                                            "
                                        >
                                            <i class="fa fa-eye"></i>
                                        </b-button>
                                    </div>
                                </template>
                                <template slot="message" slot-scope="data">
                                    <span
                                        v-b-tooltip.hover
                                        :title="data.item.message"
                                    >
                                        {{ truncate(data.item.message, 50) }}
                                    </span>
                                    <!-- {{ data.item.message}} -->
                                </template>
                                <template slot="comment" slot-scope="data">
                                    <span
                                        v-b-tooltip.hover
                                        :title="data.item.comment"
                                    >
                                        {{ truncate(data.item.comment, 50) }}
                                    </span>
                                    <!-- {{ data.item.message}} -->
                                </template>
                            </b-table>
                        </div>
                        <div style="float: right">
                            <b-pagination
                                v-model="currentPage"
                                :per-page="perPage"
                                :total-rows="contactEnquiryList.totalCount"
                                aria-controls="partner-table"
                                prev-text="Prev"
                                next-text="Next"
                                hide-goto-end-buttons
                                @change="getContactUsData"
                            ></b-pagination>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-modal
            id="modalView"
            v-model="showModalView"
            centered
            title="Enquiry Details"
            header-class="mb-3 header-text"
            footer-class="border-0 footer-button"
            modal-class="p-3"
            hide-footer
            ref="field-modal"
        >
            <div>
                <label for="name">
                    Name: <span> {{ contactDetails.name }}</span></label
                >
            </div>
            <div>
                <label for="businessName">
                    Business Name:
                    <span> {{ contactDetails.businessName }}</span></label
                >
            </div>
            <div>
                <label for="email">
                    Email: <span> {{ contactDetails.email }}</span></label
                >
            </div>
            <div>
                <label for="phone">
                    Phone Number:
                    <span> {{ contactDetails.phone }}</span></label
                >
            </div>
            <div>
                <label for="message">
                    Message : <span> {{ contactDetails.message }}</span></label
                >
            </div>
            <div>
                <label for="scope">
                    Scope : <span> {{ contactDetails.scope }}</span></label
                >
            </div>
            <div>
                <label for="status" class="d-inline-block mr-2">Status:</label>
                <eb-select
                    id="statusSelect"
                    v-model="contactDetails.status"
                    :options="enquiryStatusOptions"
                    label="text"
                    :selected="contactDetails.status"
                    placeholder="Select Status"
                    class="w-50 d-inline-block"
                    @input="updateStatus"
                ></eb-select>
            </div>
            <div>
                <!-- <label for="comment" class="d-inline-block mr-2">
                    Comment
                </label> -->
                <ValidationProvider
                    rules="required|max:60"
                    v-slot="{ errors }"
                    name="comment"
                >
                    <c-input
                        :inputId="`commenttext`"
                        inputType="text"
                        required
                        lableText="Comment*"
                        v-model="contactDetails.comment"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <b-row class="mt-4 mb-1">
                <b-col md="1"></b-col>
                <b-col md="5">
                    <b-button
                        variant="outline-primary"
                        block
                        @click="showModalView = false"
                        >CANCEL</b-button
                    ></b-col
                >
                <b-col md="5">
                    <b-button
                        variant="primary"
                        block
                        @click="updateEnquiryStatus"
                        >SAVE</b-button
                    >
                </b-col>
                <b-col md="1"></b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import CustInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select";
import cInput from "@/components/Common/CustomInput";
import dashboardInfoCard from "@/components/Generics/dashboardInfoCard.vue";
import cDate from "@/components/FormElements/CustomDate.vue";
import moment from "moment";
import { mapState } from "vuex";
import {
    ValidationProvider,
    ValidationObserver,
    Validator,
} from "vee-validate";
import { message } from "ant-design-vue";
export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        dashboardInfoCard,
        CustInput,
        ebSelect,
        cDate,
        cInput,
    },
    data() {
        return {
            loading: false,
            startDate: "",
            endDate: "",
            hideSelect: true,
            selectSearch: { text: "Name", value: "name" },
            searchValue: "",
            searchOptions: [
                { text: "Name", value: "name" },
                { text: "Email", value: "email" },
                { text: "Phone Number", value: "phoneNumber" },
            ],
            selectTenant: { text: "All Tenants", value: "all" },
            tenantOptions: [
                { text: "All Tenants", value: "all" },
                { text: "Tenant A", value: "a" },
                { text: "Tenant B", value: "b" },
            ],
            contactUsColumns: [
                {
                    label: "Name",
                    key: "name",
                },
                {
                    label: "Business Name",
                    key: "businessName",
                },
                {
                    label: "Email",
                    key: "email",
                },
                {
                    label: "Phone Number",
                    key: "phone",
                },
                {
                    label: "Message",
                    key: "message",
                },
                {
                    label: "Market",
                    key: "marketName",
                },
                {
                    label: "Status",
                    key: "status",
                },
                {
                    label: "Last Updated",
                    key: "date",
                },
                {
                    label: "Comment",
                    key: "comment",
                },
                {
                    label: "Scope",
                    key: "scope",
                },
                {
                    key: "action",
                },
            ],
            currentPage: 1,
            perPage: 10,
            showModalView: false,
            contactDetails: "",
            givenComment: "",
            enquiryStatusOptions: [
                { text: "OPEN", value: "OPEN" },
                { text: "CLOSED", value: "CLOSED" },
                { text: "CLARIFICATION", value: "CLARIFICATION" },
                { text: "REOPEN", value: "REOPEN" },
                { text: "RESOLVED", value: "RESOLVED" },
            ],
            fromDate: "",
            toDate: "",
            timeRange: "",
            selectedDurationOption: {
                text: "Today",
                value: 1,
            },
            durationOptions: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 Days",
                    value: 7,
                },
                {
                    text: "30 days",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            fromDate: moment().format("YYYY-MM-DD"),
            toDate: moment().format("YYYY-MM-DD"),
            newStatus: "",
            comment: "",
        };
    },
    computed: {
        ...mapState({
            contactEnquiryList: (state) =>
                state.contactUsEnquiry.contactEnquiryList,
        }),
        filteredList() {
            if (
                !this.contactEnquiryList ||
                !this.contactEnquiryList.serviceRequests
            ) {
                return [];
            }
            return this.contactEnquiryList.serviceRequests.map((request) => {
                console.log(request, "request");
                const {
                    reportedBy = {},
                    companyName = "",
                    marketName = "",
                    comment = "",
                    updatedAt = "",
                    status = "",
                    description = "",
                    _id = "",
                    scope = "",
                } = request;
                const { name = "", email = "", phone = "" } = reportedBy;
                return {
                    name,
                    businessName: companyName,
                    email,
                    phone,
                    comment,
                    date: moment(updatedAt).format("MM-DD-YYYY"),
                    marketName,
                    message: description,
                    status,
                    scope,
                    _id,
                };
            });
        },
    },
    methods: {
        truncate(text, length = 50) {
            if (!text) return "";
            return text.length > length ? text.slice(0, length) + "..." : text;
        },
        getValidationRules(field) {
            switch (field) {
                case "name":
                    return "required|alpha";
                case "email":
                    return "required|email";
                case "phoneNumber":
                    return "required|numeric|digits:10";
                default:
                    return "";
            }
        },
        getStatusCount(status) {
            if (
                !this.contactEnquiryList ||
                !this.contactEnquiryList.serviceRequests
            ) {
                return 0;
            }
            return this.contactEnquiryList.serviceRequests.filter(
                (request) => request.status === status,
            ).length;
        },
        updateStatus(val) {
            this.newStatus = val.value;
        },
        async changeDuration() {
            let e = this.selectedDurationOption;
            if (e.value == "custom") {
                this.hideSelect = false;
                this.$refs["compRefs"].openModal();
                setTimeout(() => {
                    this.hideSelect = true;
                }, 30);
                return;
            } else {
                this.fromDate = moment()
                    .subtract(e.value - 1, "days")
                    .format("YYYY-MM-DD");
                this.toDate = moment().format("YYYY-MM-DD");
                this.startDate = null;
                this.endDate = null;
            }
            await this.onSearchInput();
        },
        async findDateResult(e) {
            this.fromDate = e.fromDate;
            this.toDate = e.toDate;
            this.timeRange = "";
            await this.onSearchInput();
        },
        async getContactUsData(e) {
            this.currentPage = e;
            // await this.getPortfolioListData(this.search);
        },
        async onSearchInput() {
            let payload = {
                fromDate: this.fromDate,
                toDate: this.toDate,
            };

            if (this.searchValue) {
                switch (this.selectSearch?.value) {
                    case "name":
                        payload = { name: this.searchValue };
                        break;
                    case "email":
                        payload = { email: this.searchValue };
                        break;
                    case "phoneNumber":
                        payload = { phone: this.searchValue };
                        break;
                }
            }

            await this.$store.dispatch(
                "contactUsEnquiry/fetchContactEnquiryList",
                payload,
            );
        },
        async viewContactUsDetails(item) {
            this.contactDetails = item;
            this.givenComment = item.comment || "";
            this.showModalView = true;
        },
        async updateEnquiryStatus() {
            //    const isValid = await this.$refs.observer.validate();
            //   if (!isValid) return;
            const { _id, status, comment } = this.contactDetails;
            const { userName, email, phone } = this.$currentUserData;
            const payload = {
                id: _id,
                body: {
                    status: this.newStatus ? this.newStatus : status,
                    category: "67e1c19531d4efe0a060b6bd",
                    description: "update status",
                    comment: this.comment ? this.comment : comment,
                    updatedBy: {
                        name: userName,
                        email: email,
                        phone: phone,
                    },
                },
            };

            try {
                await this.$store.dispatch(
                    "contactUsEnquiry/changeContactEnquiryStatus",
                    payload,
                );
                await this.onSearchInput();
                this.showModalView = false;
                this.onSearchInput();
            } catch (error) {
                console.error("Failed to update enquiry status:", error);
            }
        },
    },
    async mounted() {
        await this.onSearchInput();
    },
};
</script>

<style scoped></style>
